<template>
  <div class="module-placeholder-wrap">
    <div class="module-placeholder">
      「{{ title }}」配置（静态占位，待接入）
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActivityModulePlaceholder',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.module-placeholder-wrap {
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
}

.module-placeholder {
  flex: 1;
  min-height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background: #fafafa;
  border: 1px dashed #d9d9d9;
  border-radius: 4px;
}

</style>
